import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { resolveLegacyRedirect } from "@/lib/legacy-redirects";

/**
 * Catch-all route για όλα τα URLs που δεν ταιριάζουν με κάποια σελίδα.
 * Χρησιμοποιείται για 301 redirects από τα παλιά PrestaShop URLs προς τα νέα.
 * Αν δεν αναγνωριστεί redirect, γυρνάμε 404 (notFoundComponent του root).
 */
export const Route = createFileRoute("/$")({
  loader: ({ params, location }) => {
    const path = "/" + (params._splat ?? "");
    const dest = resolveLegacyRedirect(path, location.searchStr ?? "");
    if (dest && dest !== path) {
      // encodeURI ώστε ελληνικοί χαρακτήρες στο slug να μη μπαίνουν αυτούσιοι
      // (non-ASCII) στο header `Location` — κάποιοι browsers/crawlers σκάνε.
      throw redirect({ href: encodeURI(dest), statusCode: 301 });
    }
    throw notFound();
  },
  component: () => null,
});